import { createApp } from 'vue'
import App from './App.vue'
import { setupRouter } from './router'
import { setupPinia } from './store'

// Vant 全局样式（按需引入时自动注入组件样式，此处补充基础重置与 Toast 等全局样式）
import 'vant/lib/index.css'
import '@/styles/index.scss'

function bootstrap() {
  const app = createApp(App)

  setupPinia(app)
  setupRouter(app)

  app.mount('#app')
}

bootstrap()
